// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"tf_a bhy_b bhy_bj","StrollerbaseBanner__hint":"tf_b bhy_vh","StrollerbaseBanner__link":"tf_c"};